import Backdrop from "@mui/material/Backdrop";
import { styled } from "@mui/material/styles";

import { EXTERNAL_ICONS } from "shared/enum";

type LoadingOverlayProps = {
  loading: boolean;
};

export default function LoadingOverlay({ loading }: LoadingOverlayProps) {
  /**
   * @see https://mui.com/components/backdrop/
   * Cant use theme here as it is not available in the context of the component
   */
  return (
    <Backdrop
      sx={{
        position: "absolute",
        backgroundColor: "#000",
        color: "#fff",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      open={loading}
    >
      {loading && <LoadingImage src={EXTERNAL_ICONS.LOADING_OVERLAY_CIRCLE_IMG} />}
    </Backdrop>
  );
}

const LoadingImage = styled("img")`
  width: 75px;
  height: 75px;
`;
